import type { SpectralAnalysisSnapshot } from '../types';
import type { EffectiveSessionDataSource } from '../services/resolveEffectiveSessionValidations';

type SessionAnalysisLike =
  | { status: 'clean' }
  | {
      status: 'needs_repair';
      duplicateCount?: number;
      gapCount?: number;
    }
  | { status: 'failed' }
  | { status: 'idle' };

type RecalculatedSessionLike = {
  source?: 'repaired' | 'effective';
};

export const computeOverviewEventMetrics = (
  snapshot: SpectralAnalysisSnapshot,
  sessionAnalysisById: Record<number, SessionAnalysisLike | undefined>,
  recalculatedSessions: Record<number, RecalculatedSessionLike | undefined>,
  sessionDataSourceById: Record<number, EffectiveSessionDataSource | undefined>
) => {
  let sessionsWithEventIssues = 0;
  let perfectSessions = 0;

  snapshot.includedSessions.forEach(item => {
    const sessionId = item.validation.sessionId;
    const analysis = sessionAnalysisById[sessionId];

    if (analysis?.status === 'needs_repair') {
      sessionsWithEventIssues += 1;
    }

    const isRepaired =
      sessionDataSourceById[sessionId] === 'hrData_repaired' ||
      recalculatedSessions[sessionId]?.source === 'repaired';

    if (analysis?.status === 'clean' || isRepaired) {
      perfectSessions += 1;
    }
  });

  return { perfectSessions, sessionsWithEventIssues };
};
